import { Component, Inject, OnInit } from '@angular/core';
import { Testbed } from 'src/app/model/testbed';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'aw-add-testers-dialog',
  templateUrl: './add-testers-dialog.component.html',
  styleUrls: ['./add-testers-dialog.component.scss']
})
export class AddTestersDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddTestersDialogComponent>,
  ) {


  }

  ngOnInit(): void {
  }

}
